<div class="attribute-editor-component">
  <div class="attribute-editor-row">
    <div class="form-group">
      <p>
        Display a session code on your screen for seamless screen sharing. Use the Screen Share feature to let others join and share content wirelessly with ease.<br>
        <a class="madero-link" href="https://help.risevision.com/hc/en-us/articles/29009023259156-How-do-I-Set-Up-Screen-Sharing-on-a-display-in-Rise-Vision" target="_blank">Learn more</a>
      </p>
    </div>
  </div>
  <div class="attribute-editor-row">
    <div class="form-group">
      <span class="flex-row left-right-aligner">
        <label for="te-sc-text-color" class="u_margin-md-bottom">Text & Icon</label>
        <color-picker
          pickerId="te-sc-text-color"
          placeholderText="Default"
          [(ngModel)]="textColor"
          (ngModelChange)="onTextColorChange()"
          ngDefaultControl
        ></color-picker>
      </span>
      <span class="flex-row left-right-aligner">
        <label for="te-sc-background-color" class="u_margin-md-bottom">Background</label>
        <color-picker
          pickerId="te-sc-background-color"
          placeholderText="Default"
          [(ngModel)]="backgroundColor"
          (ngModelChange)="onBackgroundColorChange()"
          ngDefaultControl
        ></color-picker>
      </span>
    </div>
  </div>
</div>